import svPaging from './sv-paging.vue'
export default svPaging